export const AttachmentType = {
  image: 'image',
  video: 'video',
  audio: 'audio',
  pdf: 'pdf',
  document: 'document',
};

export const AttachmentTypeOptions = [
  { value: 'image', label: 'Image' },
  { value: 'video', label: 'Video' },
  { value: 'audio', label: 'Audio' },
  { value: 'pdf', label: 'PDF' },
  { value: 'document', label: 'Document' },
];

export const getAttachmentTypeLabel = (value) => {
  const option = AttachmentTypeOptions.find(o => o.value === value);
  return option ? option.label : value;
};
